import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import limApi from "../../apis/limApi";

export const getPaymentTerms = createAsyncThunk(
    'paymentTerm/fetchAll',
    async (_, {rejectWithValue}) => {
        try {
            const response = await limApi.get('/paymentterms');
            return response.data.paymentTerms;
        } catch (e) {
            return rejectWithValue(e);
        }
    }
)

const paymentTermSlice = createSlice({
    name: 'paymentTerm',
    initialState: {
        list: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPaymentTerms.fulfilled, (state, action) => {
                state.list = action.payload.sort((a, b) => a.displayPosition - b.displayPosition);
            })
    }
});

export default paymentTermSlice.reducer;